import React from "react";
import { customColumnProps } from "@maherunlocker/custom-react-table";
import { t } from "i18next";
import { CustomIcons } from "./CustomIcons";
import CustomColumnDisplay from "@components/Common/CustomColumnDisplay";

export function ArrayOfCustomColumns({
    setRowData,
    setIsAddFoodCourtClicked,
    setLocalFilterActive,
    setIsModalOpened,
}: any): customColumnProps[] {
    return [
        {
            indexOFColumn: 1,
            columnName: t("Identifier"),
            customJsx: (e: any) => {
                return <CustomColumnDisplay text={e.selectedRow.Id} />;
            },
            filterName: t("Identifier"),
            canFilter: true,
        },
        {
            indexOFColumn: 99,
            columnName: t("Actions"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setRowData={setRowData}
                    setIsAddFoodCourtClicked={setIsAddFoodCourtClicked}
                    setLocalFilterActive={setLocalFilterActive}
                    setIsModalOpened={setIsModalOpened}
                />
            ),
        },
    ];
}
